export default "__VITE_ASSET__ec5bef58__"